import { render, staticRenderFns } from "./ProfileIncompleteAlert.vue?vue&type=template&id=5b74bf16&"
import script from "./ProfileIncompleteAlert.vue?vue&type=script&lang=js&"
export * from "./ProfileIncompleteAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports